import { Component, OnDestroy } from '@angular/core';
import {
  NavigationCancel,
  NavigationError,
  RouteConfigLoadEnd,
  RouteConfigLoadStart,
  Router,
} from '@angular/router';
import { Subject, interval, timer } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { BehaviorSubjectCollectionService } from './services/behaviorSubjectCollection.service';
import { CommonService } from './services/common/common.service';
import { UserAccessManagementService } from './services/user-access-management.service';
import { NgxSpinnerService } from 'ngx-spinner';
import * as moment from 'moment-timezone';
import { MatDialog } from '@angular/material/dialog';
import { ConfirmationDialogComponent } from './components/shared/confirmation-dialog/confirmation-dialog.component';
import { environment } from 'src/environments/environment';
import { SideBarService } from './services/common/side-bar.service';
import { VersionService } from './services/version.service';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
})
export class AppComponent {
  title = 'ZOEI';
  timerUnsubscribe: any;
  validRoute: any[] = [];
  sidebarMenu: any[] = [];
  flag: boolean = false;
  appVersion!: string;
  private readonly destroy$ = new Subject<void>();

  constructor(
    private behaviorSubjectCollection: BehaviorSubjectCollectionService,
    private commonService: CommonService,
    private _userAccessSvc: UserAccessManagementService,
    private spinner: NgxSpinnerService,
    private _dialog: MatDialog,
    private _router: Router,
    private _sidebarService: SideBarService,
    private versionService: VersionService
  ) {
    const prebootLoader = document.getElementById('preboot-loader');
    if (prebootLoader) {
      prebootLoader.remove();
    }

    this.appVersion = environment?.version;

    if (this.commonService.isUserLoggedIn()) {
      this.count();
    }
    this.commonService.userLoggedIn.subscribe((res: any) => {
      this.count();
    });

    // this.appVersionCheck();
    // interval(240000).subscribe((res: any) => {
    //   this.appVersionCheck();
    // });

    this.versionService.initVersionCheck(300000); // check every 5 minutes
    this.listenLazyRouteLoader();
  }

  private listenLazyRouteLoader() {
    this._router.events.pipe(takeUntil(this.destroy$)).subscribe(event => {
      if (event instanceof RouteConfigLoadStart) {
        this.spinner.show('lazy-route-spinner');
      } else if (
        event instanceof RouteConfigLoadEnd ||
        event instanceof NavigationCancel ||
        event instanceof NavigationError
      ) {
        this.spinner.hide('lazy-route-spinner');
      }
    });
  }

  appVersionCheck() {
    // if (localStorage.getItem('appVersion')) {
    this.commonService.appVersionCheck().subscribe((res: any) => {
      if (res?.data?.length > 0) {
        if (res?.data[0]?.version != this.appVersion) {
          // localStorage.setItem('appVersion', res.data[0].version);
          var dialogRef = this._dialog.open(ConfirmationDialogComponent, {
            width: '23.472vw',
            // height: '161px',
            data: {
              header: 'Update ?',
              data: {
                bodyData: `New version of the app is available you want to update ?`,
              },
              button: {
                isSubmit: true,
                submitbtnText: 'Update',
                isCancel: true,
                isDelete: false,
              },
            },
          });
          dialogRef.disableClose = true;

          dialogRef.afterClosed().subscribe((result: any) => {
            if (result == 'ok') {
              this.spinner.show();
              // localStorage.setItem('appVersion', res.data[0].version);
              setTimeout(() => {
                window.location.href = window.location.href;
                window.location.reload();
              }, 0);
            }
          });
        }
      }
    });
    // }
  }

  topToWindow() {
    window.scrollTo(0, 0);
  }

  count() {
    let userData: any = JSON.parse(localStorage.getItem('userData')!);
    let accessTokenExpirationTime = userData?.accessTokenExpirationTime;
    const twoMinutesInMilliseconds = 2 * 60 * 1000; // 2 minutes in milliseconds

    // Calculate the time to wait before triggering the action
    if (accessTokenExpirationTime) {
      let timeToWait =
        moment
          .utc(new Date(userData?.accessTokenExpirationTime))
          .local()
          .valueOf() -
        new Date().getTime() -
        twoMinutesInMilliseconds;

      // Create a timer observable
      const timer$ = timer(timeToWait);

      // Subscribe to the timer observable and perform the action
      this.timerUnsubscribe = timer$.subscribe(() => {
        // Your action to perform 2 minutes before the target date and time
        this.generateRefreshToken();
      });
    }
  }

  generateRefreshToken() {
    // this.spinner.show();
    this.timerUnsubscribe.unsubscribe();
    this.commonService.GenerateRefreshToken().subscribe(
      (res: any) => {
        var obj = JSON.parse(localStorage.getItem('userData')!);
        obj.accessToken = res.accessToken;
        obj.refreshToken = res.refreshToken;
        obj.accessTokenExpirationTime = res.accessTokenExpirationTime;
        localStorage.setItem('userData', JSON.stringify(obj));
        localStorage.setItem('authToken', res?.accessToken);
        this.count();
        // this.spinner.hide();
      },
      (err: any) => {
        console.log(err);
        // this.spinner.hide();
      }
    );
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }
}
